export default "__VITE_ASSET__DKIZq2JE__"